import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { applyTheme, getTheme } from './utils/theme';
import { initAnalytics } from './utils/analytics';

// Apply saved theme before first paint.
applyTheme(getTheme());

// Product analytics (no-op unless REACT_APP_POSTHOG_KEY is set).
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);





